import * as siteComponents from './Components';
import './Polyfills/classList.js';
import './Polyfills/from.js';
import './Polyfills/forEach.js';

const audioElements = document.querySelectorAll('.folkekirken-audio-element');
audioElements.forEach(audioElement => {
    new siteComponents.AudioElement(audioElement);
});
